export default __webpack_public_path__ + "static/media/womanWithChild.6243acf9.png";